export default "__VITE_ASSET__53aaa7c1__"